import { render } from "./FormRelManySimple.vue?vue&type=template&id=6656cb86"
import script from "./FormRelManySimple.vue?vue&type=script&lang=js"
export * from "./FormRelManySimple.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/DataForm/FormRelManySimple.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6656cb86"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6656cb86', __exports__)) {
    console.log('reload')
    api.reload('6656cb86', __exports__)
  }
  
  module.hot.accept("./FormRelManySimple.vue?vue&type=template&id=6656cb86", () => {
    console.log('re-render')
    api.rerender('6656cb86', render)
  })

}


export default __exports__